module.exports = __webpack_public_path__ + "img/aus-govt-logo-centered.e2e56cec.png";